import React from 'react';
import { useTranslation } from 'react-i18next';

import type { DialogProps } from '@mui/material';
import { Button } from '@mui/material';

import { HeadDialog } from 'Components';

type Props = {
  open: DialogProps['open'];
  content: React.ReactNode;
  onNo: () => void;
  onYes: () => void;
};

export const ConfirmationDialog = ({ open, content, onNo, onYes }: Readonly<Props>) => {
  const { t } = useTranslation();

  return (
    <HeadDialog
      content={content}
      buttons={
        <>
          <Button onClick={onYes} variant="outlined">
            {t('Yes')}
          </Button>
          <Button onClick={onNo} variant="outlined">
            {t('No')}
          </Button>
        </>
      }
      onClose={onNo}
      open={open}
    />
  );
};
